document.addEventListener('DOMContentLoaded', function () {

  // ----- Fade-in on scroll -----
  var fadeEls = document.querySelectorAll('.pfs-fade-in');
  if ('IntersectionObserver' in window && fadeEls.length) {
    var fadeObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('pfs-visible');
          fadeObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    fadeEls.forEach(function (el) { fadeObserver.observe(el); });
  } else {
    fadeEls.forEach(function (el) { el.classList.add('pfs-visible'); });
  }

  // ----- Number count-up -----
  var counters = document.querySelectorAll('[data-pfs-count]');
  if (!counters.length) return;

  function animateCount(el) {
    var raw = el.getAttribute('data-target') || '0';
    var target = parseFloat(raw);
    if (isNaN(target)) return;

    // capture any non-numeric suffix (mm, %, etc.) from the original setting value
    var originalText = el.getAttribute('data-original') || '';
    var suffix = originalText.replace(/[0-9.\-]/g, '');
    if (suffix) el.setAttribute('data-unit', suffix);

    var duration = 1200;
    var start = null;
    var isFloat = raw.indexOf('.') !== -1;

    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
      var current = target * eased;
      el.textContent = isFloat ? current.toFixed(1) : Math.round(current);
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = isFloat ? target.toFixed(1) : target;
      }
    }
    requestAnimationFrame(step);
  }

  if ('IntersectionObserver' in window) {
    var countObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCount(entry.target);
          countObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    counters.forEach(function (el) { countObserver.observe(el); });
  } else {
    counters.forEach(function (el) { animateCount(el); });
  }
});